export const SET_DELIVERY = 'SET_DELIVERY'
// export const SET_FIRSTTIME = 'SET_FIRSTTIME'
// export const UNLOAD_COMPONENT = 'UNLOAD_COMPONENT'
